import { COMMERCE, POSTAL_PATTERNS } from '../config';

// What Step 4 asks Recurly to price, so the tax and total on screen are the
// ones the order is invoiced with (ClickUp 869fcqyj1). Before this the page
// showed a flat 8% guess: Riverside CA 92503 read $2.96 / $39.95 while Recurly
// invoices 8.75%, $3.24 / $40.23.

// Flat-rate shipping, the same price whichever country it ships to.
export const SHIPPING_PRICE = 7.99;

// Shown only until Recurly's quote arrives, or when it can't be had.
export const estimatedTax = (first, shipping) => (first + shipping) * 0.08;

// Tax is priced from the address, and only a whole postal code is one: a
// half-typed ZIP would quote a tax for the wrong place. A country with no
// pattern here is let through on a non-empty value, as Step 3 does.
export function hasWholePostal(country, postal) {
  const shape = POSTAL_PATTERNS[country];
  return shape ? shape.test(postal || '') : Boolean(postal);
}

// Shaped for @recurly/react-recurly's useCheckoutPricing. The shipping line is a
// one-off adjustment on the shipping add-on's own item, as the purchase sends
// it (`addon`), and `coupon` is the code exactly as `applied_code` carries it.
export function buildQuoteInput({ planCode, coupon, country, postal }) {
  const where = country || 'US';
  return {
    subscriptions: [{ plan: planCode, quantity: 1, currency: 'USD' }],
    adjustments: [{
      id: 'shipping',
      itemCode: COMMERCE.shippingAddons[where] || COMMERCE.shippingAddons.US,
      amount: SHIPPING_PRICE,
      quantity: 1,
    }],
    ...(coupon ? { coupon } : {}),
    ...(hasWholePostal(where, postal) ? { address: { country: where, postal_code: postal } } : {}),
  };
}
